/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';

import type { EmployeeVisitDto } from '../models/EmployeeVisitDto';

import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

@Injectable({
  providedIn: 'root',
})
export class EmployeeVisitsService {

    constructor(public readonly http: HttpClient) {}

    /**
     * @param version 
     * @returns EmployeeVisitDto Success
     * @throws ApiError
     */
    public getVEmployeeVisits(
version: string,
): Observable<Array<EmployeeVisitDto>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/v{version}/EmployeeVisits',
            path: {
                'version': version,
            },
        });
    }

}
